import React from "react";

interface WelcomeIllustrationProps {
  className?: string;
}

export const WelcomeIllustration: React.FC<WelcomeIllustrationProps> = ({
  className = "h-24 w-24",
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* Chef hat */}
      <path
        d="M40 52C40 38 52 30 60 30C68 30 80 38 80 52V76H40V52Z"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M40 76H80V84C80 88 76 92 72 92H48C44 92 40 88 40 84V76Z"
        className="fill-primary-100 stroke-primary-300"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      {/* Hat puffs */}
      <circle
        cx="34"
        cy="52"
        r="8"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      <circle
        cx="86"
        cy="52"
        r="8"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      <circle
        cx="60"
        cy="40"
        r="10"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      {/* Face smile */}
      <circle cx="52" cy="60" r="2" className="fill-secondary-700" />
      <circle cx="68" cy="60" r="2" className="fill-secondary-700" />
      <path
        d="M54 68C56 70 60 72 64 68"
        className="stroke-secondary-700"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Sparkles */}
      <path
        d="M24 34L28 30M28 34L24 30"
        className="stroke-warning-400"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M92 38L96 34M96 38L92 34"
        className="stroke-primary-400"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default WelcomeIllustration;
